import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Token interceptor
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 → logout
api.interceptors.response.use(
  res => res,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const loginMfa = (mfaToken, code) => api.post('/auth/login/mfa', { mfaToken, code });
export const register = (data) => api.post('/auth/register', data);
export const getMe = () => api.get('/auth/me');

// Password reset
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password });

// MFA (TOTP)
export const getMfaStatus = () => api.get('/auth/mfa/status');
export const setupMfa = () => api.post('/auth/mfa/setup');
export const enableMfa = (code) => api.post('/auth/mfa/enable', { code });
export const disableMfa = (password) => api.post('/auth/mfa/disable', { password });

// Users
export const getUsers = () => api.get('/users');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const archiveUser = (id) => api.put(`/users/${id}/archive`);

// Roles
export const getRoles = () => api.get('/roles');
export const createRole = (data) => api.post('/roles', data);
export const updateRole = (id, data) => api.put(`/roles/${id}`, data);
export const deleteRole = (id) => api.delete(`/roles/${id}`);

// Permissions
export const getMyPermissions = () => api.get('/permissions/me');

// Modules
export const getModules = () => api.get('/modules');
export const getModulesOrder = () => api.get('/system/modules-order');

// System
export const getSystemConfig = () => api.get('/system/config');
export const updateSystemConfig = (key, value) => api.put(`/system/config/${key}`, { value });
export const getActivityLogs = (limit, offset) => api.get(`/system/activity-logs?limit=${limit || 50}&offset=${offset || 0}`);

export default api;
